export const ConvertDateString = (() => {
    const moment = require('moment');

    const convertForDatePicker = (dateString) =>  moment(dateString, "DD/MM/YYYY").toDate().toDateString();
    
    return {
        convertForDatePicker: convertForDatePicker,
    }
})();
